import useUser from './useUser';

export const useOrgFprint = () => useUser().getCurrentOrgFprint();
